const postfix = '- Foresight';
export const pageTitle = {
    set: (title: string) => {
        document.title = `${title} ${postfix}`;
    },
};
